export type ParentCategory = {
  name: string;
  url: string;
};

export const PARENT_CATEGORIES: ParentCategory[] = [
  {
    name: 'Moisturizer',
    url: '/collections/moisturizer/',
  },
  {
    name: 'Cleanser',
    url: '/collections/cleanser/',
  },
  {
    name: 'Masks',
    url: '/collections/mask-pack/',
  },
  {
    name: 'Sun Care',
    url: '/collections/sun-care/',
  },
  {
    name: 'Mask & Pack',
    url: '/collections/mask-pack/',
  },
];
